import { apiV2, errorHandler } from "./index";
import { API_ERROR, CLOSE_EDIT_CARD_DECK, CLOSE_EDIT_CARD_DECK_SUCCESS, DELETE_CARD_DECK, DELETE_CARD_DECK_ERROR, DELETE_CARD_DECK_SUCCESS, FETCH_CARD_DECKS, FETCH_CARD_DECKS_ERROR, FETCH_CARD_DECKS_SUCCESS, FETCH_ONE_CARD_DECK, FETCH_ONE_CARD_DECK_ERROR, FETCH_ONE_CARD_DECK_SUCCESS, SAVE_CARD_DECKS, SAVE_CARD_DECKS_ERROR, SAVE_CARD_DECKS_SUCCESS, SORT_CARD_DECKS, SORT_CARD_DECKS_ERROR, SORT_CARD_DECKS_SUCCESS } from "../constants/ActionTypes";
import Swal from "sweetalert2";
import { toast } from "../utils/v2Toast";

export function fetchAllDecks() {
    return function (dispatch) {
        dispatch({
            type: FETCH_CARD_DECKS
        });

        apiV2.get('/decks')
            .then((response) => {
                dispatch({
                    type: FETCH_CARD_DECKS_SUCCESS,
                    payload: response.data.objects || []
                })
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_CARD_DECKS_ERROR,
                    payload: []
                });
                errorHandler(dispatch, error.response, API_ERROR);
            })
    }
}

export function deleteCardDeck(id) {
    return function (dispatch) {
        dispatch({
            type: DELETE_CARD_DECK
        });

        apiV2.delete(`/decks/${id}`)
            .then(() => {
                dispatch({
                    type: DELETE_CARD_DECK_SUCCESS,
                    payload: id
                });
                Swal.fire({
                    icon: "success",
                    title: "Card Deck Deleted!",
                    timer: 2000
                });
            })
            .catch((error) => {
                dispatch({
                    type: DELETE_CARD_DECK_ERROR,
                    payload: []
                });
                errorHandler(dispatch, error.response, API_ERROR);
            })
    }
}

export function selectCardDeck(deck, onNavigate) {
    return function (dispatch) {
        dispatch({
            type: FETCH_ONE_CARD_DECK_SUCCESS,
            payload: { data: deck }
        });
        onNavigate?.();
    }
}

export function saveCardDeck(deck, onSuccess, onError) {
    return function (dispatch) {
        dispatch({
            type: SAVE_CARD_DECKS
        });

        const payload = {
            name: deck.name,
            description: deck.description,
            category_id: deck.category_id || null,
            subcategory_id: deck.subcategory_id || null,
            primary_color_hex: deck.primary_color_hex,
            module_description: deck.module_description,
            module_image_url: deck.module_image_url,
            header_image_url: deck.header_image_url,
            wrapper_image_url: deck.wrapper_image_url,
            search_result_image_url: deck.search_result_image_url,
            share_link_description: deck.share_link_description,
            share_image_url: deck.share_image_url,
            share_deeplink_url: deck.share_deeplink_url,
            purchase_store_text: deck.purchase_store_text,
            purchase_store_url: deck.purchase_store_url,
            see_all_description: deck.see_all_description,
            sort_order: deck.sort_order,
            free_view_limit: deck.free_view_limit,
            is_premium: Boolean(deck.is_premium),
            is_active: Boolean(deck.is_active),
        };

        const request = deck.id
            ? apiV2.put(`/decks/${deck.id}`, payload)
            : apiV2.post('/decks', payload);

        request
            .then(() => {
                dispatch({
                    type: SAVE_CARD_DECKS_SUCCESS,
                    payload: null
                });
                Swal.fire({
                    icon: "success",
                    title: "Card Deck Saved!",
                    timer: 1000
                }).then(() => {
                    onSuccess?.();
                })
            })
            .catch((error) => {
                dispatch({
                    type: SAVE_CARD_DECKS_ERROR,
                    payload: []
                });
                errorHandler(dispatch, error.response, API_ERROR);
                onError?.();
            })
    }
}

export function fetchOneDeck(id) {
    return function (dispatch) {
        dispatch({
            type: FETCH_ONE_CARD_DECK
        });

        apiV2.get(`/decks/${id}`)
            .then((response) => {
                dispatch({
                    type: FETCH_ONE_CARD_DECK_SUCCESS,
                    payload: { data: response.data }
                })
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_ONE_CARD_DECK_ERROR,
                    payload: []
                });
                errorHandler(dispatch, error.response, API_ERROR);
            })
    }
}

export function closeEditCardDeck(onNavigate) {
    return function (dispatch) {
        dispatch({
            type: CLOSE_EDIT_CARD_DECK
        });

        dispatch({
            type: CLOSE_EDIT_CARD_DECK_SUCCESS,
            payload: null
        });

        onNavigate?.();
    }
}

export function sortCardDeck(sortedDecks) {
    return function (dispatch) {
        dispatch({
            type: SORT_CARD_DECKS
        });

        const sortedIds = sortedDecks.map(deck => deck.id);

        apiV2.put('/decks/sort-order', { decks: sortedIds })
            .then(() => {
                dispatch({
                    type: SORT_CARD_DECKS_SUCCESS,
                    payload: sortedDecks
                });
                toast.success('Card Deck sorted!', { timer: 2000 });
            })
            .catch((error) => {
                dispatch({
                    type: SORT_CARD_DECKS_ERROR,
                    payload: []
                });
                errorHandler(dispatch, error.response, API_ERROR);
            })
    }
}
